import { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useGetLicenseCategories } from "../../repositories/licences-repository";


import ServiceOfferedTile from "../fragments/service-offered-tile";

export interface SelectedService {
    id: string;
    label: string;
    baseFee: number;
    managementFee: number | null;
    calculationDays: number | null;
    percentageRate: number | null;
}

export default function LicenceServicesOfferedForm() {
    const { register, setValue, watch, getValues } = useFormContext();

    const { licence_categories } = useGetLicenseCategories();

    const selectedCategory = watch("selectedCategory");
    
    const initializeSelectedServices = () => {
        try {
            const formValues = getValues("selectedServices");
            if (!formValues) return [];
            
            if (typeof formValues === 'string') {
                return JSON.parse(formValues);
            }
            if (Array.isArray(formValues)) {
                return formValues;
            }
            return [];
        } catch {
            return [];
        }
    };

    const [selectedServices, setSelectedServices] = useState<SelectedService[]>(initializeSelectedServices);
    useEffect(() => {
        setValue("selectedServices", selectedServices);
        setValue("licenseSubCategoryIds", selectedServices);
    }, [selectedServices, setValue]);

    const toggleSelected = (service: SelectedService) => {
        setSelectedServices((prev) =>
            prev.some((item) => item.id === service.id)
                ? prev.filter((item) => item.id !== service.id)
                : [...prev, service]
        );
    };

    const getServicesOffered = () => {
        if (!selectedCategory) return [];
        const category = licence_categories?.results?.find(
            (el: any) => el.id === selectedCategory
        );
        return (
            category?.subcategories?.map((el: any) => ({
                label: el.name,
                id: el.id,
                baseFee: el.baseFee,
                managementFee: el.managementFee,
                calculationDays: el.calculationDays,
                percentageRate: el.percentageRate,
            })) || []
        );
    };

    useEffect(() => {
        const formServices = initializeSelectedServices();
        setSelectedServices(formServices);
    }, [selectedCategory]);

    const servicesOffered = getServicesOffered();

    return (
        <div className="w-full">
            <h1 className="text-lg font-bold">Services Offered</h1>
            <p className="text-xs text-[#041528]">
                Select the specific services your business provides under the chosen category.
            </p>
            <div className="mt-3 grid grid-cols-1 gap-5">
                {servicesOffered?.map((service: SelectedService) => (
                    <ServiceOfferedTile
                        key={service.id}
                        label={`${service.label}`}
                        value={service.id}
                        isSelected={selectedServices.some((item) => item.id === service.id)}
                        toggleSelected={() => toggleSelected(service)}
                    />
                ))}
            </div>
            <input
                type="hidden"
                {...register("selectedServices", { required: true })}
                value={JSON.stringify(selectedServices)}
            />
        </div>
    );
}